import { accessJsonAttr } from '../../utils/utils';
import {MgpSelectProps } from './MgpSelect.types';


export default function MgpFormSelect({id, label, labelFontWeight, data, register, required, errors = {}, defaultValue, unshowEmptyOption, ...props }:Readonly<MgpSelectProps>)  {

    let selectClassName = "form-control input-select";
    let labelClassName = "text fw-" + (labelFontWeight ?? "medium");
    let fieldError;
    if(errors) {
        fieldError = accessJsonAttr(errors, id);
        if(fieldError) {
          selectClassName += " form-error";
          labelClassName += " form-error";
        }
    }
    const onChangeEvent = (e: any) => {     
        if(props.onChange) {
            props.onChange(e);
        }
    }
    return (
        <>
            {label &&<label className={labelClassName} htmlFor={id}>{label}{required ? <span className='fushia'> (*)</span>: ''}</label>}
            <select id={id} className={selectClassName} defaultValue={defaultValue ?? ''} {...register(id, {onChange:(e) => {onChangeEvent(e)}})} {...props}>
              
                    {!unshowEmptyOption && <option value="">Veuillez sélectionner</option>}
                    {
                        data?.map( (nomenclature, index) => 
                        <option key={index+1} value={nomenclature.code}>{nomenclature.label}</option> )
                    }
               
            </select>
            {fieldError && (<p className="error">{fieldError.message}</p>)}
        </>
  )
}
